import { mapAwards } from 'helpers/mapForSelect'

const GET_LEVELS = 'dofe-bo/award/GET_LEVELS'
const GET_LEVELS_SUCCESS = 'dofe-bo/award/GET_LEVELS_SUCCESS'
const GET_LEVELS_FAIL = 'dofe-bo/award/GET_LEVELS_FAIL'

const GET_ALLOWED = 'dofe-bo/award/GET_ALLOWED'
const GET_ALLOWED_SUCCESS = 'dofe-bo/partiawardcipant/GET_ALLOWED_SUCCESS'
const GET_ALLOWED_FAIL = 'dofe-bo/award/GET_ALLOWED_FAIL'

const SET_CURRENT_AWARD = 'dofe-web/awards/SET_CURRENT_AWARD'
const SET_CUSTOMIZATION_LOADING = 'dofe-web/awards/SET_CUSTOMIZATION_LOADING'

const initialState = {
  loading: false,
  loaded: false,
  levels: [],
  filter: '',
  current: null,
  customization: {
    loading: false,
    loaded: false,
    logo: null
  }
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_LEVELS:
      return {
        ...state,
        loading: true
      }
    case GET_LEVELS_SUCCESS:
      return {
        ...state,
        levels: mapAwards(action.result),
        loading: false,
        loaded: true
      }
    case GET_LEVELS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ALLOWED:
      return {
        ...state,
        loading: true
      }
    case GET_ALLOWED_SUCCESS:
      return {
        ...state,
        allowedLevels: mapAwards(action.result),
        loading: false,
        loaded: true
      }
    case GET_ALLOWED_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case SET_CURRENT_AWARD:
      return {
        ...state,
        customization: {
          ...state.customization,
          logoUrl: action.currentAward?.organization?.parentNAO?.logoUrl
        }
      }
    case SET_CUSTOMIZATION_LOADING:
      return {
        ...state,
        customization: {
          ...state.customization,
          loading: action.loading,
          loaded: state.customization.loaded || !action.loading
        }
      }
    default:
      return state
  }
}

export function getPublicLevels() {
  return {
    types: [GET_LEVELS, GET_LEVELS_SUCCESS, GET_LEVELS_FAIL],
    promise: client => client.get('api/participant-registrations/allowed-award-levels', {
      removeToken: true
    })
  }
}

export function getAllowedLevels(code) {
  return {
    types: [GET_ALLOWED, GET_ALLOWED_SUCCESS, GET_ALLOWED_FAIL],
    promise: client => client.get(`api/participant-registrations/allowed-award-levels/using-authorization-code?authorizationCode=${code}`, {
      removeToken: true
    })
  }
}

export function setCurrentAward(currentAward) {
  return {
    type: SET_CURRENT_AWARD,
    currentAward
  }
}

export function setAwardCustomizationLoading(loading) {
  return {
    type: SET_CUSTOMIZATION_LOADING,
    loading
  }
}
